import { render, staticRenderFns } from "./InventoryBreakdown.vue?vue&type=template&id=d1e3b47c&scoped=true"
import script from "./InventoryBreakdown.vue?vue&type=script&lang=js"
export * from "./InventoryBreakdown.vue?vue&type=script&lang=js"
import style0 from "./InventoryBreakdown.vue?vue&type=style&index=0&id=d1e3b47c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e3b47c",
  null
  
)

export default component.exports